import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useLanguage } from "./i18n";

// Se till att detta körs en gång
Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: 320,
    zIndex: 3000,
    padding: 24,
    borderRadius: 8,
  },
};

export default function PropertyModal({ feature, onSave, onCancel }) {
  const { t } = useLanguage();
  const [name, setName] = useState("");
  const [z, setZ] = useState("");
  const [radius, setRadius] = useState("");

  useEffect(() => {
    if (!feature) return;
    setName(feature.properties?.name || "");
    if (feature.geometry.type === "Point") {
      setZ(feature.geometry.coordinates[2] ?? "");
      setRadius("");
    } else if (feature.geometry.type === "LineString") {
      setZ(
        Array.isArray(feature.geometry.coordinates[0])
          ? feature.geometry.coordinates.map((c) => c[2] ?? "")
          : ""
      );
      setRadius("");
    } else if (feature.geometry.type === "Circle") {
      setZ(feature.geometry.z ?? "");
      setRadius(feature.geometry.radius ? Math.ceil(feature.geometry.radius) : "");
    } else {
      setZ("");
      setRadius("");
    }
  }, [feature]);

  if (!feature) return null;

  function handleSave(e) {
    e.preventDefault();
    if (feature.geometry.type === "LineString") {
      let zArr = [];
      if (Array.isArray(z)) {
        zArr = z.map((val) => Number(val) || 0);
      } else if (typeof z === "string" && z.includes(",")) {
        zArr = z.split(",").map((val) => Number(val.trim()) || 0);
      } else {
        zArr = feature.geometry.coordinates.map(() => Number(z) || 0);
      }
      onSave({ name: name.trim(), z: zArr });
    } else if (feature.geometry.type === "Circle") {
      // Radie sparas alltid avrundat uppåt till närmaste heltal
      onSave({ name: name.trim(), z: Number(z) || 0, radius: Math.ceil(Number(radius) || 0) });
    } else {
      onSave({ name: name.trim(), z: Number(z) || 0 });
    }
  }

  let title = t("objectProperties");
  if (feature.geometry.type === "Point") title = t("pointProperties");
  else if (feature.geometry.type === "LineString") title = t("lineProperties");
  else if (feature.geometry.type === "Circle") title = t("circleProperties");

  return (
    <Modal
      isOpen={!!feature}
      onRequestClose={onCancel}
      style={customStyles}
      contentLabel={title}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      <h2 style={{ marginTop: 0 }}>{title}</h2>
      <form onSubmit={handleSave}>
        <div style={{ marginBottom: 14 }}>
          <label>
            {t("name")}:
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ width: "100%", marginTop: 4 }}
              autoFocus
            />
          </label>
        </div>
        {(feature.geometry.type === "LineString") ? (
          <div style={{ marginBottom: 14 }}>
            <label>
              {t("lineHeightDescription")}:
              <input
                type="text"
                value={Array.isArray(z) ? z.join(",") : z}
                onChange={(e) => setZ(e.target.value)}
                placeholder={t("lineHeightPlaceholder")}
                style={{ width: "100%", marginTop: 4 }}
              />
            </label>
          </div>
        ) : (
          <div style={{ marginBottom: 14 }}>
            <label>
              {t("height")}:
              <input
                type="number"
                value={z}
                onChange={(e) => setZ(e.target.value)}
                style={{ width: "100%", marginTop: 4 }}
              />
            </label>
          </div>
        )}
        {feature.geometry.type === "Circle" && (
          <div style={{ marginBottom: 14 }}>
            <label>
              {t("radius")}:
              <input
                type="number"
                value={radius}
                onChange={(e) => setRadius(Math.ceil(Number(e.target.value) || 0))}
                style={{ width: "100%", marginTop: 4 }}
                min={1}
              />
            </label>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            type="button"
            onClick={onCancel}
            style={{
              padding: "6px 18px",
              borderRadius: 4,
              border: "1px solid #aaa",
              background: "#eee",
            }}
          >
            {t("cancel")}
          </button>
          <button
            type="submit"
            style={{
              padding: "6px 18px",
              borderRadius: 4,
              border: "1px solid #1976d2",
              background: "#1976d2",
              color: "#fff",
            }}
          >
            {t("save")}
          </button>
        </div>
      </form>
    </Modal>
  );
}